import type { SVGProps } from 'react';

export const Unlocked = ({
  className,
  ...svgProps
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 21 21"
      width="21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7828_227585)">
        <path
          d="M12.6356 7.35778V5.56711C12.6356 4.77782 12.9492 4.02085 13.5073 3.46273C14.0654 2.90462 14.8224 2.59107 15.6117 2.59107C16.401 2.59107 17.1579 2.90462 17.716 3.46273C18.2741 4.02085 18.5878 4.77782 18.5878 5.56711V7.37039H20.4162V5.56711C20.4162 4.29287 19.91 3.07081 19.009 2.16979C18.108 1.26876 16.8859 0.762573 15.6117 0.762573C14.3374 0.762573 13.1154 1.26876 12.2144 2.16979C11.3134 3.07081 10.8071 4.29287 10.8071 5.56711V7.37039L12.6356 7.35778Z"
          fill="#8DA2BD"
          fillOpacity="0.87"
          opacity="0.5"
        />
        <path
          d="M13.4425 7.30743H1.91667C1.66075 7.30069 1.40603 7.34529 1.16763 7.4386C0.929219 7.5319 0.711932 7.67203 0.528566 7.85069C0.3452 8.02936 0.199477 8.24294 0.100011 8.47884C0.000545554 8.71475 -0.0506257 8.96819 -0.050537 9.2242V18.8333C-0.050537 19.3416 0.151399 19.8292 0.510863 20.1886C0.870328 20.5481 1.3579 20.7501 1.86626 20.7501H13.3921C13.9016 20.7501 14.3904 20.5485 14.7519 20.1894C15.1134 19.8303 15.3181 19.3428 15.3215 18.8333V9.2242C15.3184 8.72331 15.1206 8.24325 14.7699 7.88554C14.4193 7.52783 13.9433 7.32051 13.4425 7.30743ZM8.65063 16.8408H6.39333V10.914H8.65063V16.8408Z"
          fill="#8DA2BD"
        />
      </g>
      <defs>
        <clipPath id="clip0_7828_227585">
          <rect
            fill="white"
            height="20"
            transform="translate(0 0.75)"
            width="20.4161"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
